var React = require('react');

function StatusClosedInverted (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Closed"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M11.5,0A11.5,11.5,0,1,0,23,11.5,11.51,11.51,0,0,0,11.5,0","style":{"fill":"#ffffff","fillRule":"evenodd"},"key":0}),React.createElement("path",{"d":"M15.65,7.35a.89.89,0,0,0-1.25,0l-2.9,2.9L8.6,7.35A.88.88,0,0,0,7.35,8.6l2.9,2.9-2.9,2.9a.89.89,0,0,0,.06,1.25.9.9,0,0,0,1.19,0l2.9-2.9,2.9,2.9a.88.88,0,0,0,1.25,0h0a.89.89,0,0,0,0-1.25l-2.9-2.9,2.9-2.9a.89.89,0,0,0,0-1.25","style":{"fill":"#d0021b","fillRule":"evenodd"},"key":1})])]);
}

StatusClosedInverted.defaultProps = {"role":"presentation","viewBox":"0 0 23 23"};

module.exports = StatusClosedInverted;

StatusClosedInverted.default = StatusClosedInverted;
